package one.healthium.ui.compose.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import ifaandroid.core.ui_kit.generated.resources.Res
import ifaandroid.core.ui_kit.generated.resources.ic_arrow_left
import ifaandroid.core.ui_kit.generated.resources.ic_arrow_left_ios
import ifaandroid.core.ui_kit.generated.resources.ic_arrow_right
import ifaandroid.core.ui_kit.generated.resources.ic_bottle
import ifaandroid.core.ui_kit.generated.resources.ic_cart_20
import ifaandroid.core.ui_kit.generated.resources.ic_checkmark_24
import ifaandroid.core.ui_kit.generated.resources.ic_checkmark_checked_orange
import ifaandroid.core.ui_kit.generated.resources.ic_checkmark_unchecked_orange
import ifaandroid.core.ui_kit.generated.resources.ic_file_checked
import ifaandroid.core.ui_kit.generated.resources.ic_pizza
import ifaandroid.core.ui_kit.generated.resources.ic_steps
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.utils.TargetPlatform
import one.healthium.ui.compose.utils.targetPlatform
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource
import org.koin.core.component.KoinComponent
import org.koin.core.component.get

object AppIcons : KoinComponent {
    val icNavigationBack = when (targetPlatform()) {
        TargetPlatform.Android -> Res.drawable.ic_arrow_left
        TargetPlatform.IOS -> Res.drawable.ic_arrow_left_ios
        TargetPlatform.Web -> Res.drawable.ic_arrow_left_ios
    }
    val icArrowRight = Res.drawable.ic_arrow_right
    val icFileChecked = Res.drawable.ic_file_checked
    val icBottle = Res.drawable.ic_bottle
    val icPizza = Res.drawable.ic_pizza
    val icSteps = Res.drawable.ic_steps
    val icCart = Res.drawable.ic_cart_20
    val icCheckMarkChecked: DrawableResource
        get() = get<IconsProvider>().icCheckMarkChecked ?: Res.drawable.ic_checkmark_checked_orange
    val icCheckMarkUnchecked: DrawableResource
        get() = get<IconsProvider>().icCheckMarkUnchecked ?: Res.drawable.ic_checkmark_unchecked_orange

    @Composable
    fun icCheckmark(
        tint: Color = AppTheme.colors.primary,
    ) {
        Image(
            modifier = Modifier
                .size(24.dp)
                .background(tint, CircleShape),
            painter = painterResource(Res.drawable.ic_checkmark_24),
            contentDescription = null,
        )
    }
}

interface IconsProvider {
    val icCheckMarkChecked: DrawableResource?
    val icCheckMarkUnchecked: DrawableResource?
}